<template>
  <span class="c-icon">
    <i
      :style="style"
      class="_icon"
    >
      <component
        :is="t"
        :style="style"
        :class="['_icon-inner', spin ? '-spin' : '']"
      />
    </i>
  </span>
</template>

<script>
import Above from 'shared/components/icons/Above.vue';
import AddReaction from 'shared/components/icons/AddReaction.vue';
import Aligned from 'shared/components/icons/Aligned.vue';
import AlignLeft from 'shared/components/icons/AlignLeft.vue';
import Apartment from 'shared/components/icons/Apartment.vue';
import Api from 'shared/components/icons/Api.vue';
import Apple from 'shared/components/icons/Apple.vue';
import Appstore from 'shared/components/icons/Appstore.vue';
import ArrowGoForward from 'shared/components/icons/ArrowGoForward.vue';
import ArrowLeft from 'shared/components/icons/ArrowLeft.vue';
import ArrowsAlt from 'shared/components/icons/ArrowsAlt.vue';
import Bars from 'shared/components/icons/Bars.vue';
import Bell from 'shared/components/icons/Bell.vue';
import Below from 'shared/components/icons/Below.vue';
import Bold from 'shared/components/icons/Bold.vue';
import Branches from 'shared/components/icons/Branches.vue';
import Calendar from 'shared/components/icons/Calendar.vue';
import CaretDown from 'shared/components/icons/CaretDown.vue';
import CaretRight from 'shared/components/icons/CaretRight.vue';
import CaretUp from 'shared/components/icons/CaretUp.vue';
import Cascade from 'shared/components/icons/Cascade.vue';
import CenterFocus from 'shared/components/icons/CenterFocus.vue';
import ChatGPT from 'shared/components/icons/ChatGPT.vue';
import Check from 'shared/components/icons/Check.vue';
import CheckCircle from 'shared/components/icons/CheckCircle.vue';
import CheckMark from 'shared/components/icons/CheckMark.vue';
import CheckMarkCircleFilled from 'shared/components/icons/CheckMarkCircleFilled.vue';
import CheckSquare from 'shared/components/icons/CheckSquare.vue';
import ChevronDown from 'shared/components/icons/ChevronDown.vue';
import ChevronLeft from 'shared/components/icons/ChevronLeft.vue';
import ChevronRight from 'shared/components/icons/ChevronRight.vue';
import ChevronUp from 'shared/components/icons/ChevronUp.vue';
import ClockCircle from 'shared/components/icons/ClockCircle.vue';
import Close from 'shared/components/icons/Close.vue';
import CloseCircle from 'shared/components/icons/CloseCircle.vue';
import Cluster from 'shared/components/icons/Cluster.vue';
import CodeIcon from 'shared/components/icons/CodeIcon.vue';
import Compass from 'shared/components/icons/Compass.vue';
import Copy from 'shared/components/icons/Copy.vue';
import CustomerService from 'shared/components/icons/CustomerService.vue';
import Dashboard from 'shared/components/icons/Dashboard.vue';
import Delete from 'shared/components/icons/Delete.vue';
import Dot from 'shared/components/icons/Dot.vue';
import DoubleLeft from 'shared/components/icons/DoubleLeft.vue';
import DoubleRight from 'shared/components/icons/DoubleRight.vue';
import Down from 'shared/components/icons/Down.vue';
import Download from 'shared/components/icons/Download.vue';
import DraftIcon from 'shared/components/icons/DraftIcon.vue';
import Drag from 'shared/components/icons/Drag.vue';
import Edit from 'shared/components/icons/Edit.vue';
import Ellipsis from 'shared/components/icons/Ellipsis.vue';
import Email from 'shared/components/icons/Email.vue';
import Enter from 'shared/components/icons/Enter.vue';
import Exclamation from 'shared/components/icons/Exclamation.vue';
import ExclamationCircleFilled from 'shared/components/icons/ExclamationCircleFilled.vue';
import ExpandMinus from 'shared/components/icons/ExpandMinus.vue';
import ExpandPlus from 'shared/components/icons/ExpandPlus.vue';
import Experiment from 'shared/components/icons/Experiment.vue';
import ExternalLink from 'shared/components/icons/ExternalLink.vue';
import Eye from 'shared/components/icons/Eye.vue';
import EyeInvisible from 'shared/components/icons/EyeInvisible.vue';
import FeedViewIcon from 'shared/components/icons/FeedViewIcon.vue';
import File from 'shared/components/icons/File.vue';
import FileImage from 'shared/components/icons/FileImage.vue';
import FileText from 'shared/components/icons/FileText.vue';
import Folder from 'shared/components/icons/Folder.vue';
import FontSize from 'shared/components/icons/FontSize.vue';
import FormIcon from 'shared/components/icons/Form.vue';
import Global from 'shared/components/icons/Global.vue';
import GoogleColor from 'shared/components/icons/GoogleColor.vue';
import Hamburger from 'shared/components/icons/Hamburger.vue';
import Headline from 'shared/components/icons/Headline.vue';
import Highlight from 'shared/components/icons/Highlight.vue';
import History from 'shared/components/icons/History.vue';
import Home from 'shared/components/icons/Home.vue';
import Inbox from 'shared/components/icons/Inbox.vue';
import Info from 'shared/components/icons/Info.vue';
import InfoCircle from 'shared/components/icons/InfoCircle.vue';
import Italic from 'shared/components/icons/Italic.vue';
import Key from 'shared/components/icons/Key.vue';
import KeyboardDown from 'shared/components/icons/KeyboardDown.vue';
import LastUpdate from 'shared/components/icons/LastUpdate.vue';
import Left from 'shared/components/icons/Left.vue';
import LeftArrowLong from 'shared/components/icons/LeftArrowLong.vue';
import LineChart from 'shared/components/icons/LineChart.vue';
import LinkIcon from 'shared/components/icons/Link.vue';
import LinkedIn from 'shared/components/icons/LinkedIn.vue';
import ListIcon from 'shared/components/icons/ListIcon.vue';
import Loading from 'shared/components/icons/Loading.vue';
import Lock from 'shared/components/icons/Lock.vue';
import Login from 'shared/components/icons/Login.vue';
import Logout from 'shared/components/icons/Logout.vue';
import LongText from 'shared/components/icons/LongText.vue';
import Lookup from 'shared/components/icons/Lookup.vue';
import Mail from 'shared/components/icons/Mail.vue';
import Message from 'shared/components/icons/Message.vue';
import More from 'shared/components/icons/More.vue';
import Move from 'shared/components/icons/Move.vue';
import MSTeams from 'shared/components/icons/MSTeams.vue';
import NetworkIcon from 'shared/components/icons/NetworkIcon.vue';
import NonAutomatic from 'shared/components/icons/NonAutomatic.vue';
import Notification from 'shared/components/icons/Notification.vue';
import Number from 'shared/components/icons/Number.vue';
import OffTrackIcon from 'shared/components/icons/OffTrackIcon.vue';
import OnTrackIcon from 'shared/components/icons/OnTrackIcon.vue';
import OpenAsPage from 'shared/components/icons/OpenAsPage.vue';
import Order from 'shared/components/icons/Order.vue';
import OrderedList from 'shared/components/icons/OrderedList.vue';
import PanelsDashboard from 'shared/components/icons/PanelsDashboard.vue';
import PaperClip from 'shared/components/icons/PaperClip.vue';
import Parent from 'shared/components/icons/Parent.vue';
import Pause from 'shared/components/icons/Pause.vue';
import Phone from 'shared/components/icons/Phone.vue';
import Plan from 'shared/components/icons/Plan.vue';
import Plus from 'shared/components/icons/Plus.vue';
import Poweroff from 'shared/components/icons/Poweroff.vue';
import Pro from 'shared/components/icons/Pro.vue';
import ProgressingIcon from 'shared/components/icons/ProgressingIcon.vue';
import Pulse from 'shared/components/icons/Pulse.vue';
import Pushpin from 'shared/components/icons/Pushpin.vue';
import PushpinFilled from 'shared/components/icons/PushpinFilled.vue';
import Puzzle from 'shared/components/icons/Puzzle.vue';
import Question from 'shared/components/icons/Question.vue';
import QuestionCircle from 'shared/components/icons/QuestionCircle.vue';
import Read from 'shared/components/icons/Read.vue';
import RedDot from 'shared/components/icons/RedDot.vue';
import Redo from 'shared/components/icons/Redo.vue';
import Retweet from 'shared/components/icons/Retweet.vue';
import Right from 'shared/components/icons/Right.vue';
import Rocket from 'shared/components/icons/Rocket.vue';
import SafetyCertificate from 'shared/components/icons/SafetyCertificate.vue';
import Save from 'shared/components/icons/Save.vue';
import Scale from 'shared/components/icons/Scale.vue';
import Schedule from 'shared/components/icons/Schedule.vue';
import Screenshot from 'shared/components/icons/Screenshot.vue';
import Search from 'shared/components/icons/Search.vue';
import Setting from 'shared/components/icons/Setting.vue';
import ShareAlt from 'shared/components/icons/ShareAlt.vue';
import Shop from 'shared/components/icons/Shop.vue';
import SingleSelect from 'shared/components/icons/SingleSelect.vue';
import Slack from 'shared/components/icons/Slack.vue';
import Smile from 'shared/components/icons/Smile.vue';
import Solution from 'shared/components/icons/Solution.vue';
import Square from 'shared/components/icons/Square.vue';
import Star from 'shared/components/icons/Star.vue';
import Status from 'shared/components/icons/Status.vue';
import StopIcon from 'shared/components/icons/Stop.vue';
import Sync from 'shared/components/icons/Sync.vue';
import Tags from 'shared/components/icons/Tags.vue';
import Team from 'shared/components/icons/Team.vue';
import Templates from 'shared/components/icons/Templates.vue';
import Threshold from 'shared/components/icons/Threshold.vue';
import Thunderbolt from 'shared/components/icons/Thunderbolt.vue';
import Tool from 'shared/components/icons/Tool.vue';
import Translate from 'shared/components/icons/Translate.vue';
import Twitter from 'shared/components/icons/Twitter.vue';
import Underline from 'shared/components/icons/Underline.vue';
import Undo from 'shared/components/icons/Undo.vue';
import UnorderedList from 'shared/components/icons/UnorderedList.vue';
import Up from 'shared/components/icons/Up.vue';
import Upgrade from 'shared/components/icons/Upgrade.vue';
import Upload from 'shared/components/icons/Upload.vue';
import User from 'shared/components/icons/User.vue';
import VideoCamera from 'shared/components/icons/VideoCamera.vue';
import Warning from 'shared/components/icons/Warning.vue';
import WelcomeScreen from 'shared/components/icons/WelcomeScreen.vue';
import ZoomIn from 'shared/components/icons/ZoomIn.vue';
import ZoomOut from 'shared/components/icons/ZoomOut.vue';

export default {
  name: 'CIcon',
  props: {
    size: {
      type: String,
      default: '16',
    },
    color: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'outlined',
    },
    spin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    OrderedList,
    Square,
    Puzzle,
    RedDot,
    Thunderbolt,
    Pro,
    Headline,
    Upgrade,
    FontSize,
    Screenshot,
    Phone,
    Status,
    SingleSelect,
    Email,
    Apple,
    LinkedIn,
    Upload,
    Aligned,
    Highlight,
    Parent,
    Lookup,
    FormIcon,
    Save,
    Copy,
    Poweroff,
    Setting,
    Drag,
    Move,
    Rocket,
    Mail,
    Enter,
    Sync,
    ZoomIn,
    ZoomOut,
    PaperClip,
    FileImage,
    CodeIcon,
    Bold,
    Italic,
    Underline,
    Login,
    Logout,
    Star,
    CustomerService,
    Warning,
    Pushpin,
    InfoCircle,
    Appstore,
    Eye,
    Info,
    ArrowLeft,
    Read,
    CheckMarkCircleFilled,
    Tool,
    ArrowsAlt,
    Schedule,
    DoubleRight,
    DoubleLeft,
    ClockCircle,
    Message,
    Smile,
    CheckSquare,
    Apartment,
    StopIcon,
    LineChart,
    Retweet,
    UnorderedList,
    Dashboard,
    History,
    Inbox,
    // Not an HTML element clash: these are keys in an icon registry rendered
    // through <component :is>, never as a bare <Search> tag, and the key is the
    // public icon name callers pass as `type`.
    // eslint-disable-next-line vue/no-reserved-component-names
    Search,
    CaretDown,
    Bell,
    Team,
    Question,
    Delete,
    Bars,
    User,
    Shop,
    SafetyCertificate,
    Notification,
    Solution,
    LinkIcon,
    Home,
    Global,
    FileText,
    File,
    Compass,
    Api,
    QuestionCircle,
    Cluster,
    CloseCircle,
    NonAutomatic,
    Branches,
    Calendar,
    PushpinFilled,
    OpenAsPage,
    Threshold,
    Plan,
    Above,
    Below,
    Close,
    Up,
    Down,
    Plus,
    Left,
    Right,
    ChatGPT,
    Experiment,
    Twitter,
    VideoCamera,
    MSTeams,
    Slack,
    KeyboardDown,
    Order,
    Ellipsis,
    Hamburger,
    ChevronRight,
    ChevronLeft,
    ChevronUp,
    Key,
    GoogleColor,
    ChevronDown,
    NetworkIcon,
    ListIcon,
    Cascade,
    CheckCircle,
    AlignLeft,
    CaretUp,
    CaretRight,
    Pause,
    AddReaction,
    CenterFocus,
    DraftIcon,
    ProgressingIcon,
    OnTrackIcon,
    OffTrackIcon,
    ArrowGoForward,
    LastUpdate,
    Download,
    ShareAlt,
    Templates,
    Translate,
    Pulse,
    Number,
    ExternalLink,
    EyeInvisible,
    ExpandPlus,
    ExpandMinus,
    LongText,
    Dot,
    Scale,
    FeedViewIcon,
    WelcomeScreen,
    PanelsDashboard,
    CheckMark,
    More,
    Tags,
    Check,
    Edit,
    Redo,
    Undo,
    Exclamation,
    ExclamationCircleFilled,
    Loading,
    Lock,
    Folder,
    LeftArrowLong,
  },
  computed: {
    style() {
      if (this.size === 'inherit' || this.size.indexOf('%') > -1 || this.size.indexOf('em') > -1) {
        return {
          fontSize: this.size,
          color: this.color,
        };
      }
      return {
        'font-size': `${this.size}px`,
        color: this.color,
      };
    },
    t() {
      return this.mapType(this.type);
    },
  },
  methods: {
    mapType(t) {
      switch (true) {
        case t === 'stop':
          return 'stop-icon';
        case t === 'link':
          return 'link-icon';
        case t === 'form':
          return 'form-icon';
        case t === 'code':
          return 'code-icon';
        default:
          return t;
      }
    },
  },
};
</script>

<style
    lang="scss"
    type="text/scss"
>
  .c-icon {
    display: flex;
    align-items: center;
    justify-content: center;

    ._icon {
      display: inline-block;
      font-style: normal;
      line-height: 0;
      text-align: center;
      text-transform: none;
      vertical-align: -.125em;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;

      ._icon-inner {
        &.-spin {
          animation: loadingCircle 1s linear infinite;

          @keyframes loadingCircle {
            100% {
              transform: rotate(1turn);
            }
          }
        }
      }
    }
  }
</style>
